import { ColDef, ICellRendererParams } from "ag-grid-community";
import { forecastedEOMColumnDef } from "./forecastedEOMColumnDef";
import { MoneyWithTooltipCellRenderer } from "../column-def-cell-renderers/money/MoneyWithTooltipCellRenderer";

export const forecastedEOMStoppableColumnDef: ColDef = {
  ...forecastedEOMColumnDef,
  cellRenderer: ({ data }: ICellRendererParams) => {
    const resource = data?.resource;

    if (!resource) {
      return null;
    }

    const tooltip =
      resource.resource_state === "stopped"
        ? "Stopped instances are charged for the attached EBS volumes."
        : "";

    return (
      <MoneyWithTooltipCellRenderer
        approximate
        billable={data?.resource?.billable}
        money={resource.forecasted_end_of_month}
        tooltip={tooltip}
      />
    );
  },
};
